import React, { useState, useEffect } from "react";

const AddNewRecipeOverViewModal = ({
                                     onClose,
                                     onSubmit,
                                     selectedPlanId,
                                     challengeData,
                                     // setChallengeData,
                                   }) => {

  const {
    challenge_name = "",
    days_of_challenge = "",
    tasks = [],
    userReferenceId = "",
    is_active = "",
  } = challengeData;

  const [formData, setFormData] = useState({
    challenge_name : challenge_name,
    days_of_challenge : days_of_challenge,
    tasks :tasks,
    userReferenceId :userReferenceId,
    is_active :is_active,
  });

  useEffect(() => {
    setFormData({
      challenge_name : challenge_name,
      days_of_challenge : days_of_challenge,
      tasks : tasks,
      userReferenceId :userReferenceId,
      is_active :is_active,
    });
  }, [challengeData, challenge_name, days_of_challenge, is_active, tasks, userReferenceId]);

  const handleSubmit = () => {
    onSubmit(formData);
    onClose()
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Add New Challenges
              </h1>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form>
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="challengeName" className="form-label font-weight-bold">
                        Challenge Name
                      </label>
                      <input
                        id="challengeName"
                        type="text"
                        className="form-control"
                        value={formData.challenge_name || ''}
                        onChange={(e) =>
                          setFormData({
                            ...challengeData,
                            challenge_name: e.target.value,
                          })
                        }

                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="daysOfChallenge" className="form-label font-weight-bold">
                        Days of Challenge
                      </label>
                      <input
                        id="daysOfChallenge"
                        type="number"
                        className="form-control"
                        value={formData.days_of_challenge}
                        onChange={(e) =>
                          setFormData({
                            ...challengeData,
                            days_of_challenge: e.target.value,
                          })
                        }

                      />
                    </div>
                  </div>
                </div>

                {challengeData?.tasks?.map((task, index) => (
                  <div
                    key={index}
                    className="row mb-4"
                    style={{
                      backgroundColor: index === 0 ? "transparent" : "",
                    }}
                  >
                    <h5 className="font-weight-bolder ">Task {index + 1}</h5>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor={`taskName${index}`} className="form-label font-weight-bold">
                          Task Name
                        </label>
                        <input
                          id={`taskName${index}`}
                          type="text"
                          className="form-control"
                          value={task.task_name}
                          onChange={(e) =>
                            setFormData({
                              ...challengeData,
                              tasks: formData.tasks.map((t, i) =>
                                i === index ? { ...t, task_name: e.target.value } : t
                              ),
                            })
                          }

                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor={`taskType${index}`} className="form-label font-weight-bold">
                          Task Type
                        </label>
                        <select
                          id={`taskType${index}`}
                          className="form-control"
                          value={task.task_type}
                          onChange={(e) =>
                            setFormData({
                              ...challengeData,
                              tasks: formData.tasks.map((t, i) =>
                                i === index ? { ...t, task_type: e.target.value } : t
                              ),
                            })
                          }

                        >
                          <option value="count-based">Count-based</option>
                          <option value="time-based">Time-based</option>
                          <option value="true/false">True/False</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor={`count${index}`} className="form-label font-weight-bold">
                          Count
                        </label>
                        <input
                          id={`count${index}`}
                          type="text"
                          className="form-control"
                          value={task.count}
                          onChange={(e) =>
                            setFormData({
                              ...challengeData,
                              tasks: formData.tasks.map((t, i) =>
                                i === index ? { ...t, count: e.target.value } : t
                              ),
                            })
                          }

                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor={`unit${index}`} className="form-label font-weight-bold">
                          Unit
                        </label>
                        <input
                          id={`unit${index}`}
                          type="text"
                          className="form-control"
                          value={task.unit}
                          onChange={(e) =>
                            setFormData({
                              ...challengeData,
                              tasks: formData.tasks.map((t, i) =>
                                i === index ? { ...t, unit: e.target.value } : t
                              ),
                            })
                          }

                        />
                      </div>
                    </div>
                  </div>
                ))}
              </form>

            </div>
            {!selectedPlanId ? (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </div>
            ) : (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {setFormData(null) ;onClose()}}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default AddNewRecipeOverViewModal;
